export default __webpack_public_path__ + "static/media/progetto-salvato.db852791.png";